import { Box, useToast } from "@chakra-ui/react";
import BreadCrumbMaker from "../../../components/BreadCrumbMaker";
import Form from "./Form";
import { useEffect, useRef, useState } from "react";
import {
  getDriverDetails,
  updateDriverDetails,
} from "../../../actions/inventory/driver.action";
import { useNavigate, useParams } from "react-router-dom";
import driverValidationSchema from "./validation.jsx";

const EditDriver = () => {
  const [data, setData] = useState({});
  const formRef = useRef();
  const params = useParams();
  const toast = useToast();
  const navigate = useNavigate();

  // Formik ab values dega, event nahi
  const handleSubmit = async (values) => {
    // console.log("in handle submit  data  values:", data);
    try {
      let id = params.id;
      const merged = { ...data, ...values };
      // console.log("merged data:", merged);
      const myformData = new FormData();
      const fileFields = {
        drivingLicenseFront: true,
        drivingLicenseBack: true,
        aadhaarCardFront: true,
        aadhaarCardBack: true,
        panCardFront: true,
      };

      Object.keys(merged).forEach((key) => {
        const value = merged[key];
        if (value === undefined || value === null) return;
        if (key in fileFields) {
          if (fileFields[key] === false) return;
          if (value instanceof File) {
            myformData.append(key, value);
          } else if (
            Array.isArray(value) &&
            value.length > 0 &&
            value[0] instanceof File
          ) {
            myformData.append(key, value[0]);
          } else if (typeof value === "string") {
            // skip existing file URLs
            return;
          }
        }
        else if (typeof value === "boolean") {
          myformData.append(key, value);
        }
        else if (value !== "") {
          myformData.append(key, value);
        }

      });
      // Append additional fields
      myformData.set("licenseHillEndorsement", merged.licenseHillEndorsement);
      myformData.set("isVerified", merged.isVerified);
      if (merged.operationalStatus) {
        myformData.set("operationalStatus", merged.operationalStatus);
      }
      if (merged.accountStatus) {
        myformData.set("accountStatus", merged.accountStatus);
      }
      // Await the API call
      await updateDriverDetails(id, myformData);
      toast({
        title: "Success",
        description: "Driver updated successfully",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      localStorage.removeItem("EditDriverFormDraft");
      navigate("/fleet-management/driver");
    } catch (error) {
      console.error("Error updating driver:", error);
      toast({
        title: "Error",
        description: error.response?.data?.message || "Failed to update driver",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const loadDetails = async () => {
    try {
      let id = params.id;
      const { data } = await getDriverDetails(id);
      setData(data);
    } catch (error) {
      console.error(error);
      toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };
  useEffect(() => {
    loadDetails();
  }, []);

  return (
    <Box w={"100%"} justifyContent={"center"} spacing={10} p={6}>
      <BreadCrumbMaker
        items={[
          { link: "", title: "Fleet Management" },
          {
            link: "/fleet-management/driver",
            title: "Driver",
          },
          {
            link: "/fleet-management/driver/edit",
            title: "Edit Driver",
            on: true,
          },
        ]}
      />
      {data && (
        <Form
          data={data}
          setData={setData}
          handleSubmit={handleSubmit}
          formRef={formRef}
          validationSchema={driverValidationSchema}
          isEditMode={true}
        />
      )}
    </Box>
  );
};

export default EditDriver;
